var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "p",
        { staticClass: "d2-mt-0" },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.$i18n.locale,
                callback: function($$v) {
                  _vm.$set(_vm.$i18n, "locale", $$v)
                },
                expression: "$i18n.locale"
              }
            },
            _vm._l(_vm.$languages, function(language) {
              return _c(
                "el-radio-button",
                { key: language.value, attrs: { label: language.value } },
                [_vm._v(" " + _vm._s(language.label) + " ")]
              )
            }),
            1
          )
        ],
        1
      ),
      _c("el-alert", {
        attrs: {
          title: _vm.$t("page.demo.playground.locales.text"),
          type: "success"
        }
      }),
      _c("d2-link-btn", {
        attrs: {
          slot: "footer",
          title: "文档",
          link: "https://d2.pub/zh/doc/d2-admin/locales"
        },
        slot: "footer"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }